import { Message } from 'element-ui'
import { ajaxPost, Baseurl } from '../api/api/api'
import CryptoJS from "crypto-js";
import router from '../router/index'

export async function VerifyPermissions(){
    window.localStorage.removeItem("eBay_code")
    window.localStorage.removeItem("wish_code")
    window.localStorage.removeItem("allegro")
    window.localStorage.removeItem("spapi_oauth_code")
    window.localStorage.removeItem("List")
    window.localStorage.removeItem("shopeeCode")
    window.localStorage.removeItem("shopeeShopID")
    window.localStorage.removeItem("shopeeCode1")
    window.localStorage.removeItem("shopeeAccountId")
    window.localStorage.removeItem("TikTok_code")
    window.localStorage.removeItem("allegro_code")
    window.localStorage.removeItem("access_token_allegro")
    window.localStorage.removeItem("refresh_token_allegro")
    window.localStorage.removeItem("access_token_aliexpress")
    window.localStorage.removeItem("refresh_token_aliexpress")
    window.localStorage.removeItem("seller_id_aliexpress")
    window.localStorage.removeItem("shoplineobj")
    window.localStorage.removeItem("selling_partner_id")
    window.localStorage.removeItem("shopifyToken")


    let str = window.location.href;
    str = str.split('#/')[0];
    let authstate = localStorage.getItem("state");
    if (GetQueryValue('shop', str) != null) {//判断url中是否有shop字段有的话执行没有就不执行
        let obj = {
            code: GetQueryValue('code', str),
            hmac: GetQueryValue('hmac', str),
            shop: GetQueryValue('shop', str).replace('.myshoplaza.com', '')
        }//准备存储url中的code hmac shop
        obj.shop = obj.shop.split('#/')[0]
        if (GetQueryValue('shop', str).indexOf('.myshopify.com') !== -1) {
            // if (GetQueryValue('state', str) != null) {
            //     if (authstate !== GetQueryValue('state', str)) {
            //         Message.error('Shopify验证失败');
            //     }
            // }

            if (str.indexOf("hmac") != -1) {
                let address1 = str.substring(str.indexOf("?") + 1, str.length);
                let splitList = address1.split("&");
                let shopifyData = new Map();
                for (let i = 0; i < splitList.length; i++) {
                    let item = splitList[i].split("=")
                    shopifyData.set(item[0], item[1])
                }
                if (address1.indexOf("code") != -1) {
                    let message1 = address1.replace(/hmac=[a-z0-9]+&/i, "")
                    let key = "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";
                    let hash = CryptoJS.HmacSHA256(message1, key).toString();
                    let hmac = shopifyData.get("hmac");
                    if (hash === hmac){
                        await getAccessToken(shopifyData.get("shop"), shopifyData.get("code"))
                    }else{
                        Message.error('验证失败')
                    }
                } else {
                    let message1 = address1.replace(/hmac=[a-z0-9]+&/i, "")
                    let key = "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";
                    let hash = CryptoJS.HmacSHA256(message1, key).toString();
                    let state = randomString(256)

                    if (address1.indexOf('session') != -1) {
                        let shop = shopifyData.get("shop")
                        let hmac = shopifyData.get("hmac")
                        localStorage.setItem("state", state);
                        hash === hmac ? window.location.href = `https://${shop}/admin/oauth/authorize?client_id=412e41c2b4640d33a3cd184d47f2a0c4&scope=read_draft_orders,read_orders,write_orders,read_price_rules,read_products,read_product_listings,read_third_party_fulfillment_orders,write_products,write_product_listings,read_inventory,write_inventory,write_fulfillments&redirect_uri=https://haihuiselling.com&state=${state}&grant_options[]=value` :
                            Message.error('验证失败')
                    } else {
                        // let arr1 = address1.replace("hmac=","").replace("shop=","").replace(".myshopify.com","").replace("timestamp=","").split("&");
                        let shop = shopifyData.get("shop")
                        let hmac = shopifyData.get("hmac")
                        localStorage.setItem("state", state);
                        hash === hmac ? window.location.href = `https://${shop}/admin/oauth/authorize?client_id=412e41c2b4640d33a3cd184d47f2a0c4&scope=read_draft_orders,read_orders,write_orders,read_price_rules,read_products,read_product_listings,read_third_party_fulfillment_orders,write_products,write_product_listings,read_inventory,write_inventory,write_fulfillments&redirect_uri=https://haihuiselling.com&state=${state}&grant_options[]=value` :
                            Message.error('验证失败')
                    }
                }
            } else {
                window.localStorage.setItem("spapi_oauth_code",  GetQueryValue('spapi_oauth_code', str))
                window.localStorage.setItem("selling_partner_id", GetQueryValue('selling_partner_id', str))
                window.localStorage.setItem("state", GetQueryValue('state', str))
            }
            const isRefresh = localStorage.getItem('isRefresh')
            if (isRefresh === '1') {
                localStorage.setItem('isRefresh', '0')
                location.reload()
            }
            // 清空url的param数据
            const { pathname, hash } = window.location;
            const newUrl = hash ? pathname + hash : pathname;
            history.replaceState(null, '', newUrl);

        } else if (GetQueryValue('shop', str).indexOf('.myshoplaza.com') !== -1) {
            //存储
            localStorage.setItem("authobj", JSON.stringify(obj));
        }
    } else if (str.indexOf("shop_id") != -1) {
        let address1 = str.substring(str.indexOf("?") + 1, str.length);
        let splitList = address1.split("&");
        let shopeeData = new Map();
        for (let i = 0; i < splitList.length; i++) {
            let item = splitList[i].split("=")
            shopeeData.set(item[0], item[1])
        }
        window.localStorage.setItem("shopeeCode", shopeeData.get('code'))
        window.localStorage.setItem("shopeeShopID", shopeeData.get('shop_id'))
    } else if (str.indexOf("main_account_id") != -1) {
        let address1 = str.substring(str.indexOf("?") + 1, str.length);
        let splitList = address1.split("&");
        let shopeeData = new Map();
        for (let i = 0; i < splitList.length; i++) {
            let item = splitList[i].split("=")
            shopeeData.set(item[0], item[1])
        }
        window.localStorage.setItem("shopeeCode1", shopeeData.get('code'))
        window.localStorage.setItem("shopeeAccountId", shopeeData.get('main_account_id'))
    } else if (GetQueryValue('selling_partner_id', str) != null) {
        window.localStorage.setItem("spapi_oauth_code",  GetQueryValue('spapi_oauth_code', str))
        window.localStorage.setItem("selling_partner_id", GetQueryValue('selling_partner_id', str))
        window.localStorage.setItem("state", GetQueryValue('state', str))
    } else if (GetQueryValue('state', str) != null && GetQueryValue('state', str).indexOf("allegro") != -1) {
        if (window.localStorage.getItem("login_set_isShouqua") == 'yes') {
            const API = Baseurl + 'allegroOauth/getToken'
            const paramsData = {
                environment: 'allegro.pl',
                code: GetQueryValue('code', str)
            }
            const res = await ajaxPost(API, paramsData);
            if (res.data.code === 200) {
                window.localStorage.setItem("access_token_allegro", res.data.data.access_token);
                window.localStorage.setItem("refresh_token_allegro", res.data.data.refresh_token);
                let allegroParams = {
                    sellerType: 11,
                    accessToken: window.localStorage.getItem("access_token_allegro"),
                    refreshToken: window.localStorage.getItem("refresh_token_allegro"),
                    company_id: localStorage.getItem('allegroCompId'),
                    environment: localStorage.getItem("allegro_countryLink_value"),
                    countryMark: localStorage.getItem("allegro_countryLink_name"),
                    shop_name: localStorage.getItem("dianpu_name")
                }
                const alleRes = await ajaxPost(Baseurl + 'allegroSeller/insertAllegroSellerInfo', allegroParams);
                const { code, data } = alleRes.data
                if (code === 200) {
                    Message.success('授权成功！')
                    window.localStorage.removeItem("allegro_code")
                    window.localStorage.removeItem("access_token_allegro")
                    window.localStorage.removeItem("refresh_token_allegro")
                    window.localStorage.removeItem("allegroCompId")
                    window.localStorage.removeItem("allegro_countryLink_value")
                    window.localStorage.removeItem("allegro_countryLink_name")
                    window.localStorage.removeItem("dianpu_name")
                    window.localStorage.removeItem("login_set_isShouqua")
                } else {
                    Message.error(data)
                }
            } else {
                Message.error(res.data.msg)
            }
        }
    } else if (GetQueryValue('state', str) != null && GetQueryValue('state', str).indexOf("aliexpress") != -1) {
        if (window.localStorage.getItem("login_set_isShouqua") == 'yes') {
            const API = Baseurl + 'aliexpressOauth/getToken'
            const paramsData = {
                code: GetQueryValue('code', str)
            }
            const res = await ajaxPost(API, paramsData)
            if (res.data.code === 200) {
                window.localStorage.setItem("access_token_aliexpress", res.data.data.access_token);
                window.localStorage.setItem("refresh_token_aliexpress", res.data.data.refresh_token);
                window.localStorage.setItem("seller_id_aliexpress", res.data.data.seller_id);
                let allegroParams = {
                    sellerType: 14,
                    accessToken: window.localStorage.getItem("access_token_aliexpress"),
                    refreshToken: window.localStorage.getItem("refresh_token_aliexpress"),
                    sellerId: window.localStorage.getItem("seller_id_aliexpress"),
                    company_id: localStorage.getItem("CompId_Aliex"),
                    shop_name: localStorage.getItem("dianpu_name_Aliex")
                }
                const alleRes = await ajaxPost(Baseurl + 'aliexpressSeller/insertAliexpressSellerInfo', allegroParams)
                const { code, data } = alleRes.data
                if (code === 200) {
                    Message.success('授权成功！')
                    window.localStorage.removeItem("access_token_aliexpress")
                    window.localStorage.removeItem("refresh_token_aliexpress")
                    window.localStorage.removeItem("seller_id_aliexpress")
                    window.localStorage.removeItem("dianpu_name_Aliex")
                    window.localStorage.removeItem("login_set_isShouqua")
                    window.localStorage.removeItem("CompId_Aliex")

                } else {
                    Message.error(data)
                }
            } else {
                Message.error(res.data.msg)
            }
        }
    } else {
        //如果url中没有那么就把之前存储过的authobj删掉
        window.localStorage.removeItem("authobj")
    }
    //判断当前页面是不是shopline授权返回的
    if (GetQueryValue('handle', str) != null) {
        str = window.location.href.split('#/')[0];
        let objone = {
            code: GetQueryValue('code', str),
            sign: GetQueryValue('sign', str),
            handle: GetQueryValue('handle', str),
            appkey: GetQueryValue('appkey', str),
            timestamp: GetQueryValue('timestamp', str)
        }//准备存储url中的code hmac shop
        localStorage.setItem("shoplineobj", JSON.stringify(objone));
    }
    const str1 = str.split('#')[0];
    // 判断页面是否有code，有的话调用tiktok接口
    if (GetQueryValue('code', str1) != null && GetQueryValue('state', str1) === 'TikTok') {
        await getTikTokToken(GetQueryValue('code', str1))
    }

    // 验证之后路由默认跳转到对应页面
    if (localStorage.getItem('data') && localStorage.getItem('token')){
        const data1 = localStorage.getItem('data') ? JSON.parse(localStorage.getItem('data')) : {};
        if (GetQueryValue('shop', str) !== null) {
            if (GetQueryValue('shop', str).indexOf('.myshopify.com') !== -1) {
                router.push({
                    name: 'ShopifyLicensing',
                    params: { data: data1 },
                })
            } else if (GetQueryValue('shop', str).indexOf('.myshoplaza.com') !== -1) {
                router.push({
                    name: 'ShoplazzaAuthorize',
                    params: { data: data1 },
                })
            } else {
                router.push({
                    name: 'Thome',
                    params: { data: data1 },
                })
            }
        } else if (GetQueryValue('handle', str) !== null) {
            router.push({
                name: 'ShoplineAuthorize',
                params: { data: data1 },
            })
        } else if (GetQueryValue('state', str1) && GetQueryValue('state', str1).indexOf('allegro') != -1) {
            router.push({
                name: 'AllegroAuthorize',
                params: { data: data1 },
            })
        } else if (GetQueryValue('state', str1) === 'wish') {
            window.localStorage.setItem("wish_code", GetQueryValue('code', str1))
            router.push({
                name: 'WishAuthorize',
                params: { data: data1 },
            })
        } else if (GetQueryValue('state', str1) === 'eBay') {
            window.localStorage.setItem("eBay_code", GetQueryValue('code', str1))
            router.push({
                name: 'eBayAuthorize',
                params: { data: data1 },
            })
        } else if (GetQueryValue('state', str1) === 'TikTok') {
            window.localStorage.setItem("TikTok_code", GetQueryValue('code', str1))
            router.push({
                name: 'TikTokAuthorize',
                params: { data: data1 },
            })
        }
    }

    
}

async function getTikTokToken(code) {
    const api = Baseurl + 'tikTok2025Oauth/getAccessToken';
    const resp = await ajaxPost(api, { code })
    if (resp.data.code === 200) {
        const res = resp.data.data;
        const access_token = res.access_token;
        const refresh_token = res.refresh_token;
        const userInfo = JSON.parse(localStorage.getItem('role'))
        const params = {
            accessToken: access_token,
            refreshToken: refresh_token,
            company_id: userInfo.company_id,
        }
        // http://192.168.1.20:8080/?app_key=6euug3muo82ml&code=ROW_eLC0uAAAAABKvpFGujLl9IPTmyHcxzQ_NDYssWYq3fPUIJV7VQkhMEqoptwNnuhMIyI1Zi_H423KAwth52kSqPI49Wp1G68Oe1WqYH2daLlnWmZgzi7Iv-1CQtnXD70rcKPljahvjN_zAISmIx6RkDWad2B-pU25&locale=zh-CN&shop_region=US&state=TikTok#/login
        const res1 = await ajaxPost(Baseurl + 'tikTok2025Seller/insertTikTokSellerInfo', params)
        if (res1.data.code === 200) {
            Message.success('授权成功！')
            // 9b29b627666e454885ba489d7133d1da
        } else {
            Message.error(res1.data.data)
        }
    } else {
        Message.error(resp.data.data)
    }
    // 清空url的param数据
    const { pathname, hash } = window.location;
    const newUrl = hash ? pathname + hash : pathname;
    history.replaceState(null, '', newUrl);
    
}
async function getAccessToken(shop, code) {
    window.localStorage.setItem("shopifySellerId", shop)
    const API = Baseurl + 'oauth/authorization'
    const paramsData = {
        shop: shop,
        code: code
    }

    const res = await ajaxPost(API, paramsData)
    if (res.data.code === 200) {
        Message.success('交换成功')
        window.localStorage.setItem("shopifyToken", res.data.data)
    } else {
        Message.error(res.data.data)
    }
}

function randomString(e) {
    e = e || 32
    let t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz123456780',
        a = t.length,
        n = ''
    for (let i = 0; i < e; i++)
        n += t.charAt(Math.floor(Math.random() * a))
    return n
}
function GetQueryValue(queryName, url) {
    let params = url.split('?')[1]
    let query = decodeURI(params);
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == queryName) {
            return pair[1];
        }
    }
    return null;
}